"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Modal = _interopRequireDefault(require("./Modal"));
var _index = require("../index");
var _excluded = ["isOpen", "closeModal", "onDelete", "title", "children", "deleteInProgress", "deleteError", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Weather or not the modal is open */
  isOpen: _propTypes["default"].bool,
  /** Title for the modal, will be the big text */
  title: _propTypes["default"].string,
  /** Content for the modal, will be the smaller text */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Function that closes the modal - will usually set some state in the parent component that would then reflect in the isOpen prop */
  closeModal: _propTypes["default"].func.isRequired,
  /** Callback to be called if the confirm button is clicked */
  onDelete: _propTypes["default"].func,
  /** Weather or not to prevent the modal from closing */
  deleteInProgress: _propTypes["default"].bool,
  /** Show an error message */
  deleteError: _propTypes["default"].string,
  /** Hook for automation will be used for the buttons with suffixes "cancel-button" and "delete-button", and passed to Modal as well */
  automationHook: _propTypes["default"].string
};
var DeleteModal = function DeleteModal(_ref) {
  var isOpen = _ref.isOpen,
    closeModal = _ref.closeModal,
    onDelete = _ref.onDelete,
    title = _ref.title,
    children = _ref.children,
    deleteInProgress = _ref.deleteInProgress,
    deleteError = _ref.deleteError,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], _extends({
    isOpen: isOpen,
    onRequestClose: closeModal,
    automationHook: automationHook
  }, rest), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_index.Heading1, {
    mB: "none"
  }, title)), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_index.Text, null, children), deleteError && /*#__PURE__*/_react["default"].createElement(_index.Text, {
    color: "error",
    mV: "base"
  }, deleteError)), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Footer, null, /*#__PURE__*/_react["default"].createElement(_index.SecondaryButton, {
    disabled: deleteInProgress,
    onClick: closeModal,
    automationHook: (0, _automationHooks.getHook)(automationHook, "cancel-button")
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_index.ButtonWithLoader, {
    automationHook: (0, _automationHooks.getHook)(automationHook, "delete-button"),
    onClick: onDelete,
    showLoader: deleteInProgress,
    buttonStyle: "danger"
  }, "Delete")));
};
DeleteModal.propTypes = propTypes;
var _default = DeleteModal;
exports["default"] = _default;